'use client';

import Link from 'next/link';
import { useQuotation } from '@/app/context/quotation-context';
import { ShoppingBag } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function QuotationCartIndicator() {
  const { itemCount } = useQuotation();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  
  // Check screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 375);
    };
    
    // Initial check
    checkScreenSize();
    
    // Check on resize
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  return (
    <Link 
      href="/cotizar/cart" 
      className="relative flex items-center text-brand-primary hover:text-brand-dark transition-colors"
      aria-label="Carrito de cotización"
    >
      <ShoppingBag size={isSmallScreen ? 18 : 20} />
      {itemCount > 0 && (
        <span className={`absolute -top-2 -right-2 bg-brand-primary ${isSmallScreen ? 'text-2xs' : 'text-xs'} rounded-full ${isSmallScreen ? 'h-4 w-4' : 'h-5 w-5'} flex items-center justify-center text-white font-bold`}>
          {itemCount}
        </span>
      )}
    </Link>
  );
} 